//
// displayNumberDigits
//
// Display a number using N digits, trims the number's higher digits
//

export default (number, digits = 3) => {
  const modulo = 10 ** digits;
  const trimmed = number % modulo;
  return trimmed.toString().padStart(digits, '0');
};
